import makeThumbnail from "./../utils/make-thumbnail";

export default function Picture(game, model) {
  Phaser.Sprite.call(this, game, 0, 0, model.get("phaserKey"));
  makeThumbnail.call(this, model);
}

Picture.prototype = Object.create(Phaser.Sprite.prototype);
Picture.prototype.constructor = Picture;
